import React from "react";
import getUltimasSalidasMaterialByUnidad from "../../services/inventario_materiales/getUltimasSalidasMaterialByUnidad";
import { validateNoNumbers } from "../../validators/validateNoNumbers";
import Table from "../Table";
import TableBody from "../Table/TableBody";
import TableHead from "../Table/TableHead";

export default function ModalUltimasSalidasMaterial({id_unidad, loading, modulosPermisos, getData}){

    const [ultimasSalidas, setUltimasSalidas] = React.useState([])
    
    const rows = [
        { id: 1, name: "Material" },
        { id: 2, name: "A quién se le dio" },
        { id: 3, name: "Cantidad" }
    ];

    const getUltimasSalidasMaterial = ()=>{
        let data = { id_unidad }

        getUltimasSalidasMaterialByUnidad({values:data})
            .then(respuesta => {
                console.log(respuesta)
                let _res = JSON.parse(respuesta)
                if(_res.response === 'success'){
                    setUltimasSalidas(_res.data)
                } else {
                    setUltimasSalidas([])
                }
            })
            .catch(err => console.log(err))
    }

    const reload = ()=>{
        getUltimasSalidasMaterial()
        getData()
    }

    React.useEffect(getUltimasSalidasMaterial, [id_unidad, loading])

    return(
        <div className="modal" id="modalUltimasSalidasMaterial" tabIndex="-1" role="dialog" aria-labelledby="modalUltimasSalidasMaterialLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content" id="formEmitirReembolso">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalUltimasSalidasMaterialLabel">
                            Últimas salidas de materiales de la unidad
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {
                            ( ultimasSalidas.length === 0 ) &&
                            <p>
                                No hay salidas recientes de materiales.
                            </p>
                        }
                        {
                            ( ultimasSalidas.length !== 0 ) &&
                            <p>
                                Estas han sido las salidas más recientes de materiales de la unidad:
                            </p>
                        }
                        {
                            ( ultimasSalidas.length !== 0 ) &&

                                <Table>
                                    <TableHead rows={rows} />

                                    <TableBody 
                                        elements={ultimasSalidas} 
                                        typeElement="salida_material_unidad" 
                                        permisosUsuario={modulosPermisos} 
                                        reload={reload}
                                        // setElementToEdit={setMaterialSelected}
                                    />
                                </Table>
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Salir</button>
                    </div>
                </div>
            </div>
        </div>
    )
}